import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

const initialState = {
  loading: false,
  data: [],
  error: "",
};

export const fetchBuildings = createAsyncThunk("get/buildings", async () => {
  const response = await axios.get(ApiList.buildingUrl);
  return response.data;
});

const buildingSlice = createSlice({
  name: "building",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBuildings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        if (action.payload.result) {
          state.data = action.payload.result;
        }
        state.error = "";
      })
      .addCase(fetchBuildings.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      });
  },
});

export default buildingSlice.reducer;
